import { useQuery } from '@tanstack/react-query';
import type { AgentApiCustomFieldsIndex } from '@/types/serializers';
import { fetchJson } from '@/utils/apiFetch';

export default function useFetchCandidateProfilesCustomFields() {
  return useQuery({
    queryKey: ['candidateProfilesCustomFields'],
    queryFn: async () => {
      const data = await fetchJson<AgentApiCustomFieldsIndex>(
        `/agent/api/candidate_profiles/custom_fields.json`
      );

      return data;
    },
  });
}
